<div class=" my-30">
    <div class="container">
        <div class=" free-trial-section h-[220px] relative rounded-2xl">
            <div class="image-wrapper w-full h-full rounded-2xl overflow-hidden">
                <img src="/images/homePage/free-trial.png" alt="" class="w-full h-full"> 
            </div>
            <div class="trial-overlay shadow-[0_0_8px_0_var(--color-accent)] items-center  grid grid-cols-12 g-3 px-10 py-5 rounded-2xl bottom-0 right-0 left-0 absolute w-full h-full bg-[linear-gradient(90deg,_#0F0F0F_2.42%,_rgba(20,15,15,0.93)_25.46%,_rgba(34,14,14,0.89)_46.72%,_rgba(172,202,69,0.40)_168.98%)]">
                <div class="col-span-12 md:col-span-9 lg:col-span-9  ">
                    <h2  class="text-xl md:text-3xl text-white font-bold mb-2">Register and start to say Action!</h2>
                    <p class="text-white text-sm">Unlock a world of entertainment made just for you — sign up now and start your journey!</p>
                </div>
                <div class=" col-span-12 lg:col-span-3">
                    <a routerLink="register" class="btn btn-primary bg-gradient-to-r from-primary to-accent/80 px-6 w-full md:w-50">Register</a>
                </div>
            </div>
        </div>
    </div>
    
</div>